import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {optionFilter} from "../../../utils/filters";

class stocktransferList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid || "stocktransferList"}
                {...props}
                view="adminlist"
                searchfield={true}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                columns={ {
                    "id": {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...(this.props.partnerType !== undefined ? {
                        [this.props.partnerType + ".name"]: {
                            header: 'Partner',
                            width: 2,
                            sortable,
                            filterable
                        }
                    } : {
                        "origin.name": {
                            header: 'Honnan',
                            width: 2,
                            sortable,
                            filterable
                        },
                        "partner.name": {
                            header: 'Partner',
                            width: 2,
                            sortable,
                            filterable
                        }
                    }),
                    "destination.name": {
                        header: 'Hova',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "transaction_date": {
                        header: 'Elszámolás dátuma',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "StockOperationState.optionlabel": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        filterField: 'state',
                        operator: '=',
                        filterable: optionFilter("StockOperationState")
                    }
                } }
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default stocktransferList;
